import { render, staticRenderFns } from "./PurchaseBackModal.vue?vue&type=template&id=5bb104b8&scoped=true"
import script from "./PurchaseBackModal.vue?vue&type=script&lang=js"
export * from "./PurchaseBackModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb104b8",
  null
  
)

export default component.exports